// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* section2.css */
/* div {
  border: 1px solid black;
} */

.section12_container__zcdQ7 {
  display: flex;
  align-items: center; /* 세로 중앙 정렬 */
  flex-direction: column;
  gap : 1px;
}

.section12_top__LvKZ7 {
  display: flex;
  justify-content: center;
  width : 100%;
  background-color: gray;
}
.section12_top__LvKZ7 p {
  cursor: pointer;
  font-size: 15px;
  color: lightgray;
}

.section12_bottom__JzayS {
  width :  100%;
  background-color: gray;
  display: flex;
}


.section12_logo__Nhdpk img {
  width: 250px;
  height: auto;
}

.section12_desc__FaOpG {
  display: flex;
  flex-direction: column;
  justify-content: center;
}


.section12_bottom__JzayS p {
  color: lightgray;
}

.section12_text1__LI4iW {
  font-weight: 800;
  line-height: 0px;
}

.section12_text3__lm4vq {
  font-size: 10px;
}


.section12_modal__EpD0d {
  padding: 20px;
  max-height: 100vh;
  overflow-y: auto;
}

/* 화면이 좁을 때: 4행 × 2열 */
@media (max-width: 1024px) {
  .section12_container__zcdQ7 {
    width : 100%;
  }
  .section12_modal__EpD0d {
    width : 80%;
  }

  .section12_top__LvKZ7 {
    padding-bottom: 1%;
  }
  .section12_bottom__JzayS {
    flex-direction: column;
    justify-content: center;
    height : 220px;
    width : 100%;
  }

  .section12_logo__Nhdpk {
    margin-left: 20px;
    display: flex;
    height: auto;
    align-items: center; 
    font-family: Jalnan2TTF;
    font-size: 24px;
  }

  .section12_text1__LI4iW {
    margin-left: 20px;
    font-weight: 800;
    line-height: 0px;
    font-size: 13px;
  }
  .section12_text2__01LVn {
    margin-left: 20px;
    font-size: 13px;
  }
  
  .section12_text3__lm4vq {
    margin-left: 20px;
    font-size: 10px;
  }
}


/* 화면이 넓을 때: 2행 × 4열 */
@media (min-width: 1025px) {
  .section12_modal__EpD0d {
    width : 50%;
  }  
  .section12_bottom__JzayS {
    height : 180px;
    justify-content: center;
    gap : 5%;
  }

  .section12_logo__Nhdpk {
    justify-content: center;
    align-items: center; 
    text-decoration: none;
    color: white;
    display: flex;
    height: 100%;
    width : 300px;
  
    font-family: Jalnan2TTF;
    font-size: 24px;
  }

  .section12_logo__Nhdpk img {
    width: 300px;
    height: auto;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/Sections/section12.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB,EAAE,aAAa;EAClC,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;;AAGA,sBAAsB;AACtB;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;;IAEb,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["/* section2.css */\n/* div {\n  border: 1px solid black;\n} */\n\n.container {\n  display: flex;\n  align-items: center; /* 세로 중앙 정렬 */\n  flex-direction: column;\n  gap : 1px;\n}\n\n.top {\n  display: flex;\n  justify-content: center;\n  width : 100%;\n  background-color: gray;\n}\n.top p {\n  cursor: pointer;\n  font-size: 15px;\n  color: lightgray;\n}\n\n.bottom {\n  width :  100%;\n  background-color: gray;\n  display: flex;\n}\n\n\n.logo img {\n  width: 250px;\n  height: auto;\n}\n\n.desc {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n\n.bottom p {\n  color: lightgray;\n}\n\n.text1 {\n  font-weight: 800;\n  line-height: 0px;\n}\n\n.text3 {\n  font-size: 10px;\n}\n\n\n.modal {\n  padding: 20px;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n\n/* 화면이 좁을 때: 4행 × 2열 */\n@media (max-width: 1024px) {\n  .container {\n    width : 100%;\n  }\n  .modal {\n    width : 80%;\n  }\n\n  .top {\n    padding-bottom: 1%;\n  }\n  .bottom {\n    flex-direction: column;\n    justify-content: center;\n    height : 220px;\n    width : 100%;\n  }\n\n  .logo {\n    margin-left: 20px;\n    display: flex;\n    height: auto;\n    align-items: center; \n    font-family: Jalnan2TTF;\n    font-size: 24px;\n  }\n\n  .text1 {\n    margin-left: 20px;\n    font-weight: 800;\n    line-height: 0px;\n    font-size: 13px;\n  }\n  .text2 {\n    margin-left: 20px;\n    font-size: 13px;\n  }\n  \n  .text3 {\n    margin-left: 20px;\n    font-size: 10px;\n  }\n}\n\n\n/* 화면이 넓을 때: 2행 × 4열 */\n@media (min-width: 1025px) {\n  .modal {\n    width : 50%;\n  }  \n  .bottom {\n    height : 180px;\n    justify-content: center;\n    gap : 5%;\n  }\n\n  .logo {\n    justify-content: center;\n    align-items: center; \n    text-decoration: none;\n    color: white;\n    display: flex;\n    height: 100%;\n    width : 300px;\n  \n    font-family: Jalnan2TTF;\n    font-size: 24px;\n  }\n\n  .logo img {\n    width: 300px;\n    height: auto;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section12_container__zcdQ7`,
	"top": `section12_top__LvKZ7`,
	"bottom": `section12_bottom__JzayS`,
	"logo": `section12_logo__Nhdpk`,
	"desc": `section12_desc__FaOpG`,
	"text1": `section12_text1__LI4iW`,
	"text3": `section12_text3__lm4vq`,
	"modal": `section12_modal__EpD0d`,
	"text2": `section12_text2__01LVn`
};
export default ___CSS_LOADER_EXPORT___;
